<template>
  <el-dialog title="选择所属部门"
             width="30%"
             :visible.sync="dialogFormVisible">
    <el-tree
      :data="data"
      :props="defaultProps"
      accordion
      @node-click="handleNodeClick">
    </el-tree>
  </el-dialog>
</template>

<script>
  export default {
    data() {
      return {
        dialogFormVisible: true,
        data: [],
        defaultProps: {
          children: 'children',
          label: 'name'
        }
      };
    },
    methods: {
      int() {
        this.dialogFormVisible = true;
        this.$httpTAG({
          url: this.$httpTAG.adornUrl('/business/sys/user/tree2'),
          method: 'post'
        }).then(r => {
          this.data = r.data.data;
        }).finally(r => {})
      },
      handleNodeClick(data) {
        this.dialogFormVisible = false;
        this.$emit("handleSelectDept",data.deptId,data.name);
      }
    }
  };
</script>

<style scoped>
</style>
